
export interface PartnerState {
  id: number;
  name: string;
  isActive: boolean;
}
